import { selectMerchant } from "@redux";
import { format } from "date-fns";
import { m } from "framer-motion";
import { t } from "i18next";
import { useState } from "react";
import { FiMinus } from "react-icons/fi";
import { useSelector } from "react-redux";

import UIStore from "src/Store/UIStore";
import styled from "styled-components";
import { SharedButton } from "./shared";
import { Redeemed } from "./shared/Redeemed";

interface IProps {
    key?: string;
    data: any;
}

export const BoxPurchases = (props: IProps) => {
    const { data, key } = props;
    const { themes } = useSelector(selectMerchant);
    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const [viewportHeight, setViewportHeight] = useState(0);
    const merchant = useSelector(selectMerchant);
    const [showpopuppage, setShowPopupPage] = useState(true);
    const [showpage1, setShowPage1] = useState(true);
    const [showpage4, setShowPage4] = useState(false);
    const [showresult, setShowResult] = useState(false);

    const handleCloseDetail = () => {
        UIStore.setState({ useDrawer: false, drawerContent: "" });
        closeAllPopup();
    };
    const closeAllPopup = () => {
        setShowPage1(true);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(true);
    };

    return (
        <>
            <div className="box-purchases" key={key}>
                <div className="img-purchases">
                    <img src={data.productImage || "https://via.placeholder.com/100"} alt="" />
                </div>
                <div className="title-purchases">
                    {data.productName ? data.productName.replace(/,/g, " ") : <FiMinus />as JSX.Element}
                </div>
                <div className="desc-purchases">
                    <div className="date">
                        <span>
                            <img src="../../images/ic-date-purchases.svg" alt="" />
                        </span>
                        {format(data.purchaseDate, "DD/MM/YYYY") || "invalid"}
                    </div>
                    <div className="brand">{data.brandName || <FiMinus />}</div>
                </div>
                <div className="status-purchases">
                    {data.status && (
                        <span
                            className={
                                data.status === "Order Received"
                                    ? "shipping"
                                    : data.status === "Delivered"
                                    ? "delivered"
                                    : "obsolete"
                            }
                        >
                            {data.status}
                        </span>
                    )}
                </div>
                <div className="detail-purchases">
                    Product serial :<span>{data.serialNumber || <FiMinus />}</span>
                </div>
                <div className="view-more">
                    <StyledButton
                        size="large"
                        bg_color={themes?.themeColor!}
                        type="submit"
                        className="confirm-btn btn-text"
                        onClick={() => {
                            // setShowPopup(true);
                            UIStore.setState({
                                useDrawer: true,
                                drawerContent: (
                                    <>
                                        <StyledShowPopup
                                            // initial={{ y: "100vh" }}
                                            // animate={{ y: 0 }}
                                            // exit={{ y: "100vh" }}
                                            // transition={{
                                            //     type: "spring",
                                            //     stiffness: 100,
                                            //     damping: 20,
                                            // }}
                                            themeColor={themes?.themeColor!}
                                            themePageColor={
                                                merchant?.luckyDrawDisplaySetting?.themeColor!
                                            }
                                        >
                                            <div className="page-wrapper">
                                                {/* <div className="close" onClick={handleCloseDetail}>
                                                    <IConClose width={16} />
                                                </div> */}
                                                {showpopuppage ? (
                                                    <div className="content-layout">
                                                        <div className="content">
                                                            {showpage1 ? (
                                                                <>
                                                                    <div className="header-product">
                                                                        <div className="layout-img">
                                                                            <div className="img-product">
                                                                                <img
                                                                                    src={
                                                                                        data.productImage ||
                                                                                        ""
                                                                                    }
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="topic-product">
                                                                            {data.productName ? (
                                                                                data.productName.replace(
                                                                                    /,/g,
                                                                                    " "
                                                                                )
                                                                            ) : (
                                                                                <FiMinus />
                                                                            )}
                                                                        </div>
                                                                        <div className="expier-product">
                                                                            <span
                                                                                className={
                                                                                    data.status ===
                                                                                    "Order Received"
                                                                                        ? "shipping"
                                                                                        : data.status ===
                                                                                          "Delivered"
                                                                                        ? "delivered"
                                                                                        : "obsolete"
                                                                                }
                                                                            >
                                                                                {data.status || (
                                                                                    <FiMinus />
                                                                                )}
                                                                            </span>
                                                                            Expected delivery date :
                                                                            {format(
                                                                                data.estDeliveryDate,
                                                                                "DD/MM/YYYY"
                                                                            ) || "invalid"}
                                                                        </div>
                                                                    </div>
                                                                    <div className="warranty-layout">
                                                                        <div className="warranty-box">
                                                                            {/* <span>
                                                                                Warranty number :
                                                                                {data.warrantyNumber ||
                                                                                    "invalid"}{" "}
                                                                                (EXP:
                                                                                {format(
                                                                                    data.expirationDate,
                                                                                    "DD/MM/YYYY"
                                                                                ) || "invalid"}
                                                                                )
                                                                            </span> */}
                                                                            <span>
                                                                                Warranty period :{" "}
                                                                                {data.warrantyPeriod ? (
                                                                                    data.warrantyPeriod +
                                                                                    " months"
                                                                                ) : (
                                                                                    <FiMinus />
                                                                                )}
                                                                            </span>
                                                                            <span>
                                                                                Serial :{" "}
                                                                                {data.serialNumber || (
                                                                                    <FiMinus />
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="text-purchases">
                                                                        Purchased :{" "}
                                                                        {format(
                                                                            data.purchaseDate,
                                                                            "DD/MM/YYYY"
                                                                        ) || "invalid"}
                                                                    </div>
                                                                    {/* <div className="text-purchases">
                                                                        Sales :{" "}
                                                                        {data.sales || "invalid"}(
                                                                        {data.salesTel || "invalid"}
                                                                        )
                                                                    </div> */}
                                                                    <div className="btn-purchases">
                                                                        <StyledUsedBtn
                                                                            className="btn-redeem"
                                                                            themeColor={
                                                                                themes?.themeColor!
                                                                            }
                                                                            themePageColor={
                                                                                merchant
                                                                                    ?.luckyDrawDisplaySetting
                                                                                    ?.themeColor!
                                                                            }
                                                                            href="tel:095-555-5555"
                                                                        >
                                                                            Contact service
                                                                        </StyledUsedBtn>
                                                                    </div>
                                                                </>
                                                            ) : null}

                                                            {showresult && (
                                                                <>
                                                                    <div className="content-info">
                                                                        <div className="header-product">
                                                                            <div className="layout-img">
                                                                                <div className="img-product">
                                                                                    <img
                                                                                        src={
                                                                                            "../../images/img-sub-luckydraw.png"
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="topic-product">
                                                                                test title
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="action-layout">
                                                                        <div className="qr-layout">
                                                                            <div className="qr-box">
                                                                                {/* <QRCode
                                                                        value={
                                                                            resultData?.luckydraw
                                                                                ?.ticketCode || ""
                                                                        }
                                                                        size={150}
                                                                    /> */}
                                                                            </div>
                                                                            <StyledCodeButton
                                                                                mainColor={
                                                                                    themes?.themeColor
                                                                                }
                                                                                themePageColor={
                                                                                    merchant
                                                                                        ?.luckyDrawDisplaySetting
                                                                                        ?.themeColor!
                                                                                }
                                                                            >
                                                                                {/* {resultData?.luckydraw
                                                                        ?.ticketCode || "---"} */}
                                                                            </StyledCodeButton>
                                                                        </div>
                                                                        <p className="redeemed-product">
                                                                            <span className="redeemed">
                                                                                <Redeemed color="#336C51" />
                                                                            </span>
                                                                            REDEEMED
                                                                        </p>
                                                                        <p className="note">
                                                                            {t("page.desLuckydraw")}
                                                                        </p>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </StyledShowPopup>
                                        {/* <BlurBackground
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            exit={{ opacity: 0 }}
                                        /> */}
                                    </>
                                ),
                            });
                        }}
                    >
                        View
                    </StyledButton>
                </div>
            </div>
            {/* <LazyMotion features={domAnimation}>
                <AnimatePresence>
                    
                </AnimatePresence>
            </LazyMotion> */}
        </>
    );
};

const StyledButton = styled(SharedButton)`
    padding: 6px 13px;
    background-color: #000;
    font-size: 12px;
    line-height: 15px;
    color: #fff;
    height: auto;
    width: auto;
`;

const StyledShowPopup = styled(m.div)<{ themeColor: string; themePageColor: string }>`
    height: 70dvh;
    width: "100%";
    position: relative;
    /* display: flex; */
    align-items: center;
    justify-content: center;
    /* background: rgba(0, 0, 0, 0.5); */
    /* z-index: 10; */
    /* left: 50%; */
    /* transform: translateX(-50%); */
    /* flex-direction: column; */
    /* justify-content: end; */
    /* transition: 2s !important; */
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .topic-popup-product {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        justify-content: center;
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        /* animation: bottomtotop 0.5s !important;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .page-wrapper {
        position: fixed;
        width: 100%;
        .close {
            cursor: pointer;
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .form-content-product {
        border-radius: 6px;
        margin-bottom: 10px;
        .title {
            font-size: 16px;
            color: #676767;
            margin: 10px 0;
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        /* margin-bottom: 27px; */
        border-radius: 6px;
    }
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        position: relative;
        /* animation: bottomtotop 0.5s !important;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            /* background: ${(props) =>
                props?.themePageColor !== ""
                    ? `${props?.themePageColor}`
                    : `${props?.themeColor}`}; */
            // background-color: ${(p) => p.themeColor};
            /* width: 100%; */
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(props) =>
                    props?.themePageColor !== ""
                        ? `${props?.themePageColor}`
                        : `${props?.themeColor}`};
                // color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
    .content-layout {
        height: auto;
        min-height: 80dvh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        /* animation: bottomtotop 0.5s !important; */
        /* @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        .content {
            background: transparent !important;
        }
        .btn-redeem {
            /* color: #fff;
            background: ${(props) =>
                props?.themePageColor !== ""
                    ? `${props?.themePageColor}`
                    : `${props?.themeColor}`}; */
            // background-color: ${(p) => p.themeColor};
            /* width: 100%; */
            /* padding: 10px 0; */
            font-size: 13px;
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            margin-top: -100px;
            padding-bottom: 20px;
            .result-luckydraw {
                padding: 12px;
                background-color: rgba(51, 108, 81, 0.08);
                border-radius: 12px;
                position: relative;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .result-img-luckydraw {
                    margin-right: 16px;
                    img {
                        width: 100px;
                        height: 100px;
                    }
                }
                .text-giftset {
                    h2 {
                        font-size: 18px;
                        line-height: 21px;
                        color: #000;
                        font-weight: 600;
                    }
                    p {
                        font-size: 12px;
                        line-height: 16px;
                        margin-bottom: 0;
                        color: #9b9b9b;
                    }
                }
            }
            .layout-img {
                text-align: center;
                .img-product {
                    width: 150px;
                    height: 150px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
                /* margin-bottom: 16px; */
                span {
                    padding: 3px 8px;
                    background-color: #ddd;
                    color: #000000;
                    border-radius: 30px;
                    font-size: 11px;
                    line-height: 14px;
                    margin-right: 5px;
                }
                .shipping {
                    background-color: #ff800b12;
                    color: #ff800b;
                }
                .delivered {
                    background-color: rgba(38, 194, 164, 0.12);
                    color: #26c2a4;
                }
                .obsolete {
                    background-color: rgba(255, 0, 0, 0.12);
                    color: #9b9b9b;
                }
            }

            .process-product {
                max-width: 200px;
                margin: 10px auto;
                .ant-progress-inner {
                }
                .ant-progress-bg {
                    background-color: ${(p) => p.themeColor};
                }
            }
        }
        .warranty-layout {
            padding-bottom: 18px;
            border-bottom: 1px solid #fcf4e4;
            margin-bottom: 14px;
            .warranty-box {
                padding: 8px 0;
                text-align: center;
                border: 0.5px dashed #c4a363;
                background-color: #c4a36312;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                span {
                    display: block;
                    font-size: 12px;
                    line-height: 15px;
                    color: #c4a363;
                }
            }
        }
        .text-purchases {
            color: #9b9b9b;
            font-size: 12px;
            line-height: 15px;
            text-align: center;
        }
        .btn-purchases {
            margin-top: 24px;
            text-align: center;
        }
        .content-product {
            padding: 16px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(props) =>
                    props?.themePageColor !== ""
                        ? `${props?.themePageColor}`
                        : `${props?.themeColor}`};
                // color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            // padding: 10px;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
    }
    .title {
        line-height: 19px;
        color: ${(p) => p.theme.colors.color};
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 16px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 100px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const StyledUsedBtn = styled.a<{ themeColor: string; themePageColor: string }>`
    padding: 14px 46px;
    /* color: ${(p) => p.themeColor}; */
    color: #fff;
    width: auto;
    /* background: ${(props) =>
        props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.themeColor}`}; */
    // background: ${(p) => p.theme.colors.card};
    background-color: #000;
    /* border: 0.5px solid ${(p) => p.themeColor}; */
    /* border-radius: 40px; */
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
    text-decoration: none;
`;
const StyledCodeButton = styled.div<{ mainColor?: string; themePageColor: string }>`
    position: absolute;
    background: ${(props) =>
        props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.mainColor}`};
    // background: ${(p) => p.mainColor};
    border-radius: 80px;
    height: 26px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    bottom: 0;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
`;
const BlurBackground = styled(m.div)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
`;
